import { useEffect, useState } from "react";
import { Card, Divider, Typography, Spin, Select, Tag, message } from "antd";

import { PlusOutlined } from "@ant-design/icons";
import axiosInstance from "../../../../api/Axios";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { formatDateWithSuffix } from "../../../../components/icons/ApplicationColor";
const { Title, Text } = Typography;
const { Option } = Select;

const BundleRightBar = ({ data1, loading, LoadUser, ImpersonateAccess }) => {
  const { id } = useParams();
  const [messageApi, contextHolder] = message.useMessage();
  const userInfo = useSelector((state) => state.user);

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");

  const [inputValue, setInputValue] = useState("");
  const [tags, setTags] = useState(
    Array.isArray(data1?.tags) ? data1.tags : []
  );

  // Update tags if data1?.tags changes (e.g., after fetch)
  useEffect(() => {
    if (Array.isArray(data1?.tags)) {
      setTags(data1.tags);
    }
  }, [data1?.tags]);
  const handleInputChange = (val) => {
    setInputValue(val);
  };

  const handleAddTag = async (updatedTags) => {
    try {
      await axiosInstance.put(
        `learn/bundle/${id}/`,
        {
          ...data1,
          organization: userInfo?.data?.organization?.id,
          tags: updatedTags,
        },
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      CreateSuccessfull();
    } catch (err) {
      CreateFailed();
    }
  };
  const CreateSuccessfull = () => {
    LoadUser();
    messageApi.open({
      type: "success",
      content: "Bundle Tags Updated Successfully",
      duration: 5,
    });
  };

  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Bundle Tag failed",
      duration: 5,
    });
  };
  const [popularTags, setPopularTags] = useState([]);
  useEffect(() => {
    const TagsRetrive = async () => {
      try {
        const res = await axiosInstance.get("/taglist/");
        console.log(res);
        setPopularTags(res?.data);
      } catch (err) {
        console.log(err);
      }
    };

    TagsRetrive();
  }, []);
  return (
    <Card
      bordered
      hoverable
      style={{
        width: "100%",
        padding: "12.5px",
        paddingTop: "5px",
        height: "100%",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        background: "#F9FBFC",
      }}
    >
      {contextHolder}
      <Spin spinning={loading}>
        <Title
          // level={}
          style={{
            fontSize: "15.5px",
            textAlign: "center",
            width: "100%",
            // display: "block",
            fontWeight: "600",
            letterSpacing: 0.5,
            color: "#333333",

            marginBottom: 16,
          }}
        >
          Bundle Details
        </Title>
        <Divider />
        <div
          style={{
            width: "100%",
            textAlign: "left",
            gap: "12.5px",
            display: "flex",
            flexDirection: "column",
            marginInlineStart: "5px",
          }}
        >
          <div>
            <Text style={{ color: "gray" }}>Name : </Text>
            <Text>{data1?.name}</Text>
          </div>
          <div>
            <Text style={{ color: "gray" }}>Bundle ID : </Text>
            <Text>{data1?.bundle_id}</Text>
          </div>
          <div>
            <Text style={{ color: "gray" }}>Due Date : </Text>
            <Text>{formatDateWithSuffix(data1?.due_date)}</Text>
          </div>
          <div>
            <Text style={{ color: "gray" }}>Deactivation : </Text>
            <Text>{formatDateWithSuffix(data1?.deactivate_on)}</Text>
          </div>
        </div>
        <Divider />
        <div style={{ margin: "12px 0 0 0" }}>
          <Text
            style={{
              fontSize: 14.75,
              textAlign: "center",
              width: "100%",
              display: "block",
              fontWeight: "600",
              letterSpacing: 0.5,
              color: "#666",
            }}
          >
            Relevant Tags
          </Text>
          <div
            style={{
              marginTop: 18,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Select
              mode="tags"
              style={{
                minWidth: 220,
                maxWidth: 400,
                marginBottom: 12,
                borderRadius: 16,
              }}
              placeholder="Add or select tags"
              value={[]}
              onChange={async (value) => {
                // Only add new tags
                const newTags = value.filter((tag) => !tags.includes(tag));
                if (newTags.length > 0) {
                  setTags([...tags, ...newTags]);
                  await handleAddTag([...tags, ...newTags]);
                } else {
                  setTags(value);
                  await handleAddTag(value);
                }
              }}
              onInputKeyDown={(e) => {
                if (e.key === "Enter" && inputValue.trim()) {
                  handleAddTag();
                  e.preventDefault();
                }
              }}
              onSearch={handleInputChange}
              showSearch
              disabled={!ImpersonateAccess}
              dropdownStyle={{ borderRadius: 12 }}
              suffixIcon={
                ImpersonateAccess && (
                  <PlusOutlined
                    style={{
                      color: "#1677ff",
                      fontWeight: "bold",
                      fontSize: 18,
                    }}
                    onClick={handleAddTag}
                  />
                )
              }
              maxTagCount={5}
              maxTagTextLength={20}
            >
              {popularTags
                ?.filter((tag) => !tags.includes(tag.name))
                ?.map((tag) => (
                  <Option key={tag.id} value={tag.name}>
                    {tag.name}
                  </Option>
                ))}
            </Select>
            <div style={{ textAlign: "center", marginTop: 6 }}>
              {tags.map((tag) => (
                <Tag
                  key={tag}
                  closable={ImpersonateAccess}
                  onClose={async () => {
                    const updatedTags = tags.filter((t) => t !== tag);
                    setTags(updatedTags);
                    await handleAddTag(updatedTags);
                  }}
                  color="geekblue"
                  style={{
                    fontSize: 14,
                    padding: "4px 12px",
                    borderRadius: "16px",
                    marginBottom: 6,
                    marginRight: 6,
                    marginTop: 6,
                  }}
                >
                  {tag}
                </Tag>
              ))}
            </div>
          </div>
        </div>
      </Spin>
    </Card>
  );
};

export default BundleRightBar;
